const hasTimezone = (date: string): boolean => /Z|[+-]\d{2}(:?\d{2})?$/.test(date);

export const isWithinHours = (date: unknown, hours: number): boolean => {
  if (!date || typeof date !== 'string') return false;

  const normalizedDate = hasTimezone(date) ? date : `${date}Z`;
  const pastDate = new Date(normalizedDate);
  if (isNaN(pastDate.getTime())) return false;

  const now = new Date();
  const diffInHours = (now.getTime() - pastDate.getTime()) / (1000 * 60 * 60);
  return diffInHours >= 0 && diffInHours < hours;
};
